import React from "react"
import { assembleSrc } from "../icons/icon"
import { iconsList as icons } from "../icons/icons-list"

export function LinkPreview({ properties }) {
  const { icon } = properties

  const label = getLabelForIcon(icon)

  return (
    <div className="flex items-center">
      <img
        src={assembleSrc(icon, "#000000", "#ffffff", "icon-only")}
        className="w-6 h-6 mr-4"
        alt={label}
      />
      <div className="text-left flex-grow truncate w-48">
        {properties.text || properties.url || "Link"}
      </div>
    </div>
  )
}

function getLabelForIcon(name) {
  const target = icons.find(icon => icon.name === name)

  if (!target) {
    return "Icon"
  } else {
    return target.label
  }
}
